import { type PropsWithChildren } from 'react';
import { classNames } from '@utils/classNames';

export const ActionButtons = ({
  children,
  className,
}: PropsWithChildren<{ className?: string }>) => {
  if (!children) {
    return null;
  }
  return (
    <div
      className={classNames(
        'flex flex-col sm:flex-row justify-center sm:justify-end',
        'gap-3 sm:gap-1',
        'pt-3 px-4 sm:pt-0 sm:px-0',
        'border-t border-slate-300 sm:border-0',
        'shadow-[0_-4px_24px_rgba(12,63,85,0.12)] sm:shadow-none',
        'sticky',
        className,
      )}
    >
      {children}
    </div>
  );
};
